module.exports = __webpack_public_path__ + "static/media/Lens-Radiant Charm_diameter.c2825cdb.png";